/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import { createTheme } from '@mui/material/styles';
import ThemeEnum from './enums/theme.enum';

const darkTheme = createTheme({
  typography: {
    fontFamily: '"DM Sans", system-ui',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: (themeOrProps) => {
          const theme = themeOrProps?.theme ?? themeOrProps;
          return {
          textTransform: 'none',
          // No transition on color: avoids flash when toggling disabled (toolbar Valida)
          transition: theme.transitions.create(
            ['background-color', 'box-shadow', 'border-color'],
            { duration: theme.transitions.duration.short }
          ),
          };
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#fff',
          color: 'rgba(0, 0, 0, 0.78)',
          fontSize: 12,
          fontWeight: 500,
          padding: '6px 10px',
          borderRadius: 6,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(0, 0, 0, 0.08)',
        },
        arrow: {
          color: '#fff',
          '&::before': {
            border: '1px solid rgba(0, 0, 0, 0.08)',
          },
        },
      },
    },
  },
  palette: {
    mode: ThemeEnum.DARK_MODE,
    primary: {
      main: '#1F76F1',
    },
    secondary: {
      main: '#000',
    },
    error: {
      main: '#ff4c51',
    },
    info: {
      main: '#4d4e50',
      light: '#37383a',
    },
    background: {
      default: '#000',
      paper: '#000',
      secondary: '#1F1F1F',
      contrast: '#393939'
    },
  },
});

export default darkTheme;
